import React from 'react'

const NotFound = () => {
  return (
    <div>
      notFound page
    </div>
  )
}

export default NotFound
